<template>
    <div>
        <Card :padding="0">
            <p slot="title" class="card-title">
                <Icon type="map"></Icon>
                学校和用户总量折线图
            </p>
            <div style="height: 360px">
                <div style="width:100%;height:100%;" id="school-user-wrap" v-show="!isShow"></div>
                <div class="chart-error" v-show="isShow">
                    <div class="detail">
                        <span class="detail">暂无数据</span>
                    </div>
                </div>
            </div>
        </Card>
    </div>
</template>

<script>
    export default {
        name: "school-user-num",
        props:{
            wisdomDataList:Array
        },
        watch:{
            wisdomDataList: {
                handler(newValue, oldValue) {
                   this.initDataSource();
                },
                deep: true
            }
        },
        data () {
            return {
                isShow: false//是否显示缺醒图
            }
        },
        methods: {
            /**
             * 初始化图表
             */
            initDataSource () {
                let dataSource = this.$echarts.init(
                    document.getElementById("school-user-wrap")
                );
                let dataArr = [];
                let schoolCountList = [];
                let userCountList = [];
                //判断是否显示缺省图
                if (this.wisdomDataList.length > 0) {
                    this.isShow = false;
                    for (let i = 0; i < this.wisdomDataList.length; i++) {
                        dataArr.push(this.wisdomDataList[i].timeKey);
                        schoolCountList.push(this.wisdomDataList[i].schoolTotal);
                        userCountList.push(this.wisdomDataList[i].userTotal);
                    }
                } else {
                    this.isShow = true;
                }
                const option = {
                    tooltip: {
                        trigger: "axis",
                        //自定义内容
                        formatter: function (params) {
                            var htmlStr = '';
                            for (var i = 0; i < params.length; i++) {
                                var param = params[i];
                                var xName = param.name;//x轴的名称
                                var seriesName = param.seriesName;//图例名称
                                var value = param.value;//y轴值
                                var color = param.color;//图例颜色

                                if (i === 0) {
                                    htmlStr += xName + '<br/>';//x轴的名称
                                }
                                htmlStr += '<div>';
                                //为了保证和原来的效果一样，这里自己实现了一个点的效果
                                htmlStr += '<span style="margin-right:5px;display:inline-block;width:10px;height:10px;border-radius:5px;background-color:' + color + ';"></span>';

                                //圆点后面显示的文本
                                htmlStr += seriesName + '：' + value + '个';

                                htmlStr += '</div>';
                            }
                            return htmlStr;
                        }
                    },
                    legend: {
                        data: ['学校', '用户'],
                        align: "left",
                        left: 0
                    },
                    color: [
                        "LightPink",
                        "LightBlue"
                    ],
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data: dataArr
                    },
                    yAxis: {
                        type: 'value',
                        axisLabel: {
                            formatter: '{value}个'
                        }
                    },
                    series: [
                        {
                            name: '用户',
                            type: 'line',
                            data: userCountList
                        },
                        {
                            name: '学校',
                            type: 'line',
                            data: schoolCountList
                        }
                    ]
                };
                dataSource.setOption(option);
                window.addEventListener("resize", function () {
                    dataSource.resize();
                });
            }
        },
        mounted () {
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../style/home";
</style>
